// @flow

import { AccordionText } from '@boi/core/lib';
import React from 'react';

import { ExternalLink } from '../../components/ExternalLink/ExternalLink';
import { commonFormStylesIdentifier } from '../../constants';
import { boiMarketingPreferenceUrl } from '../../constants/externalLinks';
import { marketingPhoneNumber } from '../../constants/phoneNumbers';

const className = 'c-MarketingConsentPage';

const ConsentText = () => {

  return (
    <div className={`${className}__readMoreContainer`}>
      <div className={`${className}__visibleText`}>
        We{"'"}d like to contact you occasionally with news of products, services and offers from Bank of Ireland Group and select trusted partners.
      </div>
      <AccordionText
        label="Find out more"
        labelColor="inherit"
        openLabel="Read less"
        underline
        inverted
      >
        <div
          className={`${className}__readMoreContent ${commonFormStylesIdentifier}__infoText`}
        >
          <div className={`${className}--spaceBellow`}>
            <span className={`${className}--bold`}>
              When you give us permission to get in touch, you are allowing
              members of Bank of Ireland Group to send you information about
              relevant products, services and offers.
            </span>
          </div>

          <div className={`${className}--spaceBellow`}>
            We will only send you information that we think you might be interested in, can make your life easier, or offer you value for money.
          </div>

          <div className={`${className}--spaceBellow`}>
            <span className={`${className}--bold`}>
              You can choose the way we contact you for marketing.
            </span>{' '}
            <br />
            This can be through any combination of email, phone, or push notifications on your mobile app.
          </div>

          <div className={`${className}--spaceBellow`}>
            <span className={`${className}--bold`}>
              Stay in control of your data.
            </span>{' '}
            <br />
            You can {' '}<ExternalLink url={boiMarketingPreferenceUrl} text="change your marketing preferences online" />{' '}
             24/7 or by call us on {' '}
            <a href={`tel:${marketingPhoneNumber}`}>{marketingPhoneNumber}</a>{' '}
            between 9am and 5pm. Do not want to receive our marketing emails? Click the unsubscribe option at the end of the marketing email.
          </div>


          <div className={`${className}--spaceBellow`}>
            <span className={`${className}--bold`}>
              Bank of Ireland Group includes the following companies.
            </span>{' '}
            <br />
            Bank of Ireland, Bank of Ireland Mortgage Bank u.c., Bank of Ireland
            Insurance Services Limited, Bank of Ireland Leasing Limited, J&E
            Davy trading as Davy and New Ireland Assurance Company plc.
          </div>
        </div>
      </AccordionText>
    </div>
  );
};

export default ConsentText;
